import React, { useState } from 'react';
import { Grid, Table, Divider } from 'semantic-ui-react';
import get from 'lodash.get';

import { Field } from 'react-final-form';
import { validators } from 'forms';
import { Product, ProductId } from 'services/products/types';
import { FieldArray } from 'react-final-form-arrays';
import classnames from 'classnames';
import ButtonLink from 'components/ButtonLink';
import FertilizerProductsDropdown from 'components/FertilizerProductsDropdown';
// @ts-ignore
import ResponsiveTable from 'components/ResponsiveTable';
import FieldValues from 'components/FieldValues';
import { FertilizerEventProduct } from 'services/fertilizerEvents/types';
import FertilizerEventProductsTableRow from './components/FertilizerEventProductsTableRow';
import FertilizerEventProductDetails from './components/FertilizerEventProductDetails';
import FertilizerEventProductRatePerUnitTypeDropdown from './components/FertilizerEventProductRatePerUnitTypeDropdown';
import FertilizerEventProductUnitsPerAreaField from './components/FertilizerEventProductUnitsPerAreaField';
import FertilizerEventNumberOfTreesWarning from './components/FertilizerEventNumberOfTreesWarning';

const {
    isRequired,
    isNumber,
    isPositiveNumber,
    composeValidators,
    maxValue1000000
} = validators;

const validateProducts = (
    values: Record<string, any>
): Record<string, string>[] => {
    const ids: ProductId[] = [];
    const errors: Record<string, string>[] = [];

    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    values &&
        values.forEach((product: FertilizerEventProduct, index: number) => {
            const { id } = product;

            if (ids.includes(id)) {
                errors[index] = {
                    id: 'This product has already been used in this fertilizer'
                };
            } else {
                ids.push(id);
            }
        });
    return errors;
};

export default function FertilizerEventProductPage(): React.ReactElement {
    const [selectedRow, setSelectedRow] = useState(0);

    return (
        <div className="spray-event-modal-step || product-page">
            <FieldArray name="fertilizerProducts" validate={validateProducts}>
                {(props: any): React.ReactElement => {
                    const { fields, meta } = props;
                    const { error, submitFailed }: any = meta;

                    return (
                        <React.Fragment>
                            <Grid>
                                <Grid.Row>
                                    <Grid.Column width="8">
                                        <h4>Product list</h4>
                                    </Grid.Column>
                                </Grid.Row>
                                <Grid.Row>
                                    <Grid.Column width="16">
                                        <Field
                                            name="fertilizerProducts"
                                            subscription={{ value: true }}
                                        >
                                            {({
                                                input: { value }
                                            }): React.ReactElement => (
                                                <ResponsiveTable>
                                                    <Table
                                                        selectable
                                                        singleLine
                                                        single
                                                        unstackable
                                                        size="small"
                                                    >
                                                        <Table.Body>
                                                            {value &&
                                                                value.map(
                                                                    (
                                                                        product: Product,
                                                                        index: number
                                                                    ) => {
                                                                        const invalid =
                                                                            submitFailed &&
                                                                            error &&
                                                                            error[
                                                                                index
                                                                            ];

                                                                        return (
                                                                            <FertilizerEventProductsTableRow
                                                                                invalid={
                                                                                    invalid
                                                                                }
                                                                                productId={
                                                                                    product.id
                                                                                }
                                                                                index={
                                                                                    index +
                                                                                    1
                                                                                }
                                                                                key={
                                                                                    `${index}-${product.id}` // eslint-disable-line react/no-array-index-key
                                                                                }
                                                                                handleRowClick={(): void =>
                                                                                    setSelectedRow(
                                                                                        index
                                                                                    )
                                                                                }
                                                                                handleOnDeleteRowClick={(
                                                                                    event
                                                                                ): void => {
                                                                                    event.stopPropagation();

                                                                                    const lastOneSelected =
                                                                                        fields
                                                                                            .value
                                                                                            .length -
                                                                                            1 ===
                                                                                        selectedRow;

                                                                                    fields.remove(
                                                                                        index
                                                                                    );

                                                                                    if (
                                                                                        lastOneSelected &&
                                                                                        selectedRow !==
                                                                                            0
                                                                                    ) {
                                                                                        setSelectedRow(
                                                                                            selectedRow -
                                                                                                1
                                                                                        );
                                                                                    } else if (
                                                                                        selectedRow ===
                                                                                            index &&
                                                                                        index !==
                                                                                            0
                                                                                    ) {
                                                                                        setSelectedRow(
                                                                                            index -
                                                                                                1
                                                                                        );
                                                                                    }
                                                                                }}
                                                                                handleOnSortingUpClick={(
                                                                                    event
                                                                                ): void => {
                                                                                    event.stopPropagation();

                                                                                    if (
                                                                                        index >
                                                                                        0
                                                                                    ) {
                                                                                        fields.move(
                                                                                            index,
                                                                                            index -
                                                                                                1
                                                                                        );
                                                                                    }
                                                                                }}
                                                                                handleOnSortingDownClick={(
                                                                                    event
                                                                                ): void => {
                                                                                    event.stopPropagation();

                                                                                    if (
                                                                                        index <
                                                                                        value.length -
                                                                                            1
                                                                                    ) {
                                                                                        fields.move(
                                                                                            index,
                                                                                            index +
                                                                                                1
                                                                                        );
                                                                                    }
                                                                                }}
                                                                                displayActions={
                                                                                    value.length >
                                                                                    1
                                                                                }
                                                                                displayErrors={
                                                                                    submitFailed &&
                                                                                    error
                                                                                }
                                                                            />
                                                                        );
                                                                    }
                                                                )}
                                                        </Table.Body>
                                                    </Table>
                                                </ResponsiveTable>
                                            )}
                                        </Field>
                                    </Grid.Column>
                                </Grid.Row>
                                <Grid.Row>
                                    <Grid.Column width="16" textAlign="center">
                                        <ButtonLink
                                            classNames="new-product-button"
                                            buttonProps={{
                                                primary: true,
                                                type: 'button'
                                            }}
                                            onClick={(): void => {
                                                fields.push({
                                                    productId: null
                                                });

                                                // eslint-disable-next-line @typescript-eslint/no-unused-expressions
                                                fields.length &&
                                                    setSelectedRow(
                                                        fields.length
                                                    );
                                            }}
                                        >
                                            + Add new product
                                        </ButtonLink>
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid>
                            <Divider />
                            <FieldValues
                                fieldNames={[
                                    'fertilizerProducts',
                                    'fertilizerEntityIds'
                                ]}
                            >
                                {({
                                    fertilizerProducts,
                                    fertilizerEntityIds
                                }): any => {
                                    const product = get(
                                        fertilizerProducts,
                                        selectedRow
                                    );

                                    const { id, perUnitType } = product;

                                    return fields.map(
                                        (
                                            name: string,
                                            index: number
                                        ): React.ReactElement | null => {
                                            const productsFormsClass =
                                                classnames(
                                                    'product-page-form',
                                                    {
                                                        hidden:
                                                            selectedRow !==
                                                            index
                                                    }
                                                );

                                            return (
                                                <Grid
                                                    key={
                                                        fertilizerProducts[
                                                            index
                                                        ].id
                                                    }
                                                    className={
                                                        productsFormsClass
                                                    }
                                                >
                                                    <Grid.Row>
                                                        <Grid.Column width="8">
                                                            <h4>{`Product ${
                                                                index + 1
                                                            }`}</h4>
                                                        </Grid.Column>
                                                    </Grid.Row>
                                                    <Grid.Row>
                                                        <Grid.Column width="8">
                                                            <FertilizerProductsDropdown
                                                                name={`${name}.id`}
                                                                validate={
                                                                    isRequired
                                                                }
                                                            />
                                                        </Grid.Column>
                                                        <Grid.Column
                                                            computer="4"
                                                            mobile="4"
                                                        >
                                                            <FertilizerEventProductUnitsPerAreaField
                                                                name={name}
                                                                validate={composeValidators(
                                                                    isRequired,
                                                                    isNumber,
                                                                    isPositiveNumber,
                                                                    maxValue1000000
                                                                )}
                                                            />
                                                        </Grid.Column>
                                                        <Grid.Column
                                                            computer="4"
                                                            mobile="6"
                                                        >
                                                            <FertilizerEventProductRatePerUnitTypeDropdown
                                                                name={`${name}.perUnitType`}
                                                                productId={id}
                                                            />
                                                        </Grid.Column>
                                                    </Grid.Row>
                                                    <Grid.Row>
                                                        <Grid.Column>
                                                            {product && (
                                                                <FertilizerEventProductDetails
                                                                    product={
                                                                        product
                                                                    }
                                                                    productId={
                                                                        product.id
                                                                    }
                                                                    orderIntoTank={
                                                                        selectedRow +
                                                                        1
                                                                    }
                                                                    entityIds={
                                                                        fertilizerEntityIds
                                                                    }
                                                                    perUnitType={
                                                                        perUnitType
                                                                    }
                                                                />
                                                            )}
                                                        </Grid.Column>
                                                    </Grid.Row>
                                                    <FertilizerEventNumberOfTreesWarning
                                                        entityIds={
                                                            fertilizerEntityIds
                                                        }
                                                        perUnitType={
                                                            perUnitType
                                                        }
                                                        productId={product.id}
                                                    />
                                                </Grid>
                                            );
                                        }
                                    );
                                }}
                            </FieldValues>
                        </React.Fragment>
                    );
                }}
            </FieldArray>
        </div>
    );
}
